/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Catalog_Invalid_CursorInputs */

const en_us2_catalog_invalid_cursor = /** @type {(inputs: Catalog_Invalid_CursorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We lost your place in the list. Pull to refresh.`)
};

const pt_br2_catalog_invalid_cursor = /** @type {(inputs: Catalog_Invalid_CursorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perdemos seu lugar na lista. Puxe para atualizar.`)
};

const es_419_catalog_invalid_cursor = /** @type {(inputs: Catalog_Invalid_CursorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perdimos tu lugar en la lista. Desliza hacia abajo para actualizar.`)
};

const pt_pt2_catalog_invalid_cursor = /** @type {(inputs: Catalog_Invalid_CursorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perdemos o teu lugar na lista. Puxa para atualizar.`)
};

const fr_fr2_catalog_invalid_cursor = /** @type {(inputs: Catalog_Invalid_CursorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta position dans la liste a été perdue. Tire pour actualiser.`)
};

const de_de2_catalog_invalid_cursor = /** @type {(inputs: Catalog_Invalid_CursorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listenposition verloren. Zum Aktualisieren ziehen.`)
};

const it_it2_catalog_invalid_cursor = /** @type {(inputs: Catalog_Invalid_CursorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbiamo perso il punto in cui eri nell'elenco. Trascina giù per aggiornare.`)
};

/**
* | output |
* | --- |
* | "We lost your place in the list. Pull to refresh." |
*
* @param {Catalog_Invalid_CursorInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const catalog_invalid_cursor = /** @type {((inputs?: Catalog_Invalid_CursorInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Catalog_Invalid_CursorInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_catalog_invalid_cursor(inputs)
	if (locale === "es-419") return es_419_catalog_invalid_cursor(inputs)
	if (locale === "pt-PT") return pt_pt2_catalog_invalid_cursor(inputs)
	if (locale === "fr-FR") return fr_fr2_catalog_invalid_cursor(inputs)
	if (locale === "de-DE") return de_de2_catalog_invalid_cursor(inputs)
	if (locale === "it-IT") return it_it2_catalog_invalid_cursor(inputs)
	return en_us2_catalog_invalid_cursor(inputs)
});
export { catalog_invalid_cursor as "catalog.invalid_cursor" }